import moment from "moment-timezone";
import {Tooltip} from "@mui/material";
import CakeIcon from "@mui/icons-material/Cake";
import React from "react";

const SHOW_CAKE_ICON_BEFORE_DAYS = -7;
const SHOW_CAKE_ICON_AFTER_DAYS = 2;

// Just one day difference is fine to skip in case of a leap year
const ONE_YEAR_IN_DAYS = 365;

const DATE_FORMAT_WITHOUT_YEAR = 'DD-MM';
const DATE_FORMAT_FOR_TOOLTIP = 'ddd DD MMM';

const cakeIconStyle = {
  color: "grey",
  borderRadius: "50%",
  backgroundColor: "white",
  padding: "0.188rem",
  marginRight: "0.1rem",
  marginBottom: "0.2rem",
};

export default function ChildBirthdayIndicatorIcon({dateOfBirth}) {

    const isBirthdayWithinRange = (dateOfBirth) => {

        const today = moment(moment().format(DATE_FORMAT_WITHOUT_YEAR), DATE_FORMAT_WITHOUT_YEAR);
        const birthday = moment(moment(dateOfBirth).format(DATE_FORMAT_WITHOUT_YEAR), DATE_FORMAT_WITHOUT_YEAR);
        const differenceInDays = today.diff(birthday, 'days') % ONE_YEAR_IN_DAYS;

        const isValidRangeToShowCakeIcon = SHOW_CAKE_ICON_BEFORE_DAYS < differenceInDays && differenceInDays <= SHOW_CAKE_ICON_AFTER_DAYS;

        return isValidRangeToShowCakeIcon;
    }

    const showCakeIcon = isBirthdayWithinRange(dateOfBirth);
    const formattedDateOfBirth = moment(dateOfBirth).year(moment().year()).format(DATE_FORMAT_FOR_TOOLTIP);

    return <>
        {showCakeIcon && <Tooltip title={formattedDateOfBirth}><CakeIcon sx={cakeIconStyle}/></Tooltip>}
    </>;
}
